import { systemLib } from 'shared';

const CONSUMERS = {
  android: {
    name: import.meta.env.VITE_PFM_ANDROID_CONSUMER_NAME,
    key: import.meta.env.VITE_PFM_ANDROID_CONSUMER_KEY,
  },
  ios: {
    name: import.meta.env.VITE_PFM_IOS_CONSUMER_NAME,
    key: import.meta.env.VITE_PFM_IOS_CONSUMER_KEY,
  },
};

const consumer = CONSUMERS[systemLib.getMobileOperatingSystem()];

export default {
  isDevRuntimeEnv:
    import.meta.env.VITE_RUNTIME_ENV &&
    import.meta.env.VITE_RUNTIME_ENV === 'development',
  isStagRuntimeEnv:
    import.meta.env.VITE_RUNTIME_ENV &&
    import.meta.env.VITE_RUNTIME_ENV === 'staging',
  isProdRuntimeEnv:
    import.meta.env.VITE_RUNTIME_ENV &&
    import.meta.env.VITE_RUNTIME_ENV === 'production',
  TSO_NAME: import.meta.env.VITE_TSO_NAME ?? 'Aviata',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  GOOGLE_ANALYTICS_TAG_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_TAG_ID,
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  AMPLITUDE_DEPLOYMENT_KEY: import.meta.env.VITE_AMPLITUDE_DEPLOYMENT_KEY,
  pfm: {
    consumer,
    baseUrl: import.meta.env.VITE_PFM_BASE_URL,
    docAiBaseUrl: import.meta.env.VITE_PFM_DOC_AI_BASE_URL,
    pollingIntervals: {
      international: {
        OW: [1, 1, 1, 1, 2],
        RT: [1, 1, 1, 1, 2],
      },
      domestic: {
        OW: [1],
        RT: [1],
      },
    },
  },
  aiConcierge: {
    // Dedicated base URL for the AI Travel Concierge backend. Falls back to the
    // PFM gateway path so the client stays same-origin (concierge JSON endpoints
    // send no CORS headers; only the SSE response does).
    baseUrl:
      import.meta.env.VITE_AI_CONCIERGE_BASE_URL ||
      `${import.meta.env.VITE_PFM_BASE_URL}/ai-concierge/api`,
  },
};
